import { render } from "./BlockHeader.vue?vue&type=template&id=26867b91&ts=true"
import script from "./BlockHeader.vue?vue&type=script&lang=ts"
export * from "./BlockHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__